import { HashRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Index from "./pages/Index";

function App() {
  return (
    <HashRouter>
      <div>
        <ToastContainer />
      </div>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/recording" element={<Index />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
